import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
	setPaymentMethod
 } from '../../_redux/actions/cmDrConsulta';
import FormField from '../../style/styledComponents/FormField';
import { Formik, Form, Field } from 'formik';
import TermAndConditions from '../TermAndConditions';
import { FiAlertCircle } from 'react-icons/fi';

class FormAdyen extends Component {
	constructor(props) {
		super(props);
		this.state = {
			paymentMethodDebit: props.paymentMethod.debit,
			paymentMethodCredit: props.paymentMethod.credit,
			paymentMethodPix: props.paymentMethod.pix,
			termos: false,
			errorOnField: [],
			numberOfInstallment: '',
			terminal: null
		};
		this.initialValues = {...this.state};
		this.checkField = this.checkField.bind(this);
		this.sendPaymentForm = this.sendPaymentForm.bind(this);
		this.handlePaymentMethod = this.handlePaymentMethod.bind(this);
		this.clearErrorOnFocus = this.clearErrorOnFocus.bind(this);
		this.changeTerm = this.changeTerm.bind(this);
		this.getData = this.getData.bind(this);
	}
	componentDidMount() {
		if (this.props.installments) {
			this.setState({
				numberOfInstallment: this.props.installments
			});
			this.initialValues.numberOfInstallment = this.props.installments;
		}
	}

	checkField(name, value) {
		let fieldChecked = false;

		if (name === 'termos') {
			fieldChecked = value;
		} else if (name === 'terminal') {
			fieldChecked = value;
		} else {
			fieldChecked = true;
		}

		return fieldChecked;
	}

	sendPaymentForm() {
		const { paymentMethod } = this.props;
		let inputData = this.state;
		inputData.paymentMethodCredit = paymentMethod.credit
		inputData.paymentMethodDebit = paymentMethod.debit
		inputData.paymentMethodPix = paymentMethod.pix
		let error = false;
		let errObj = {};
		for (var fieldName in inputData) {
			if (!this.checkField(fieldName, inputData[fieldName])) {
				if (fieldName === 'termos') {
					error = true;
					errObj = {
						...errObj,
						[fieldName]: 'É necessário aceitar os termos para continuar.'
					};
				}
				if (fieldName === 'terminal') {
					error = true;
					errObj = {
						...errObj,
						[fieldName]: 'É necessário selecionar um terminal.'
					};
				}
			}
		}

		if (!inputData.paymentMethodCredit && !inputData.paymentMethodDebit && !inputData.paymentMethodPix) {
			error = true;
			errObj = {
					...errObj,
					paymentMethod: 'É necessário selecionar ao menos um método de pagamento.'
			};
		}

		const hasError = error;
		this.props.notSend();
		if (!hasError) {
			this.props.onSend();
		} else {
			this.setState({ errorOnField: errObj });
		}
	}

	handlePaymentMethod(e) {
		const { name, checked } = e.target;
		const { setPaymentMethod, paymentMethod } = this.props;
		
		const newPaymentMethod = {
			...paymentMethod,
			[name]: checked, 
		};
		if (checked) {
			for (const key in newPaymentMethod) {
				if (key !== name) {
					newPaymentMethod[key] = false;
				}
			}
		}
		setPaymentMethod(newPaymentMethod);

				
		this.props.onPixSelected(newPaymentMethod.pix)
			
		const isAnyMethodSelected = newPaymentMethod.credit || newPaymentMethod.debit || newPaymentMethod.pix;

		if (isAnyMethodSelected) {
			this.clearErrorOnFocus('paymentMethod');
		}
		
	}

	clearErrorOnFocus(field) {
    this.setState(prevState => ({
			errorOnField: {
				...prevState.errorOnField,
				[field]: null
			}
    }));
	}


	changeTerm(e) {
		this.clearErrorOnFocus('termos');
		const isChecked = this.state.termos ? true : false;
		this.setState(
			{
				termos: e.target.checked,
				errorMsg: isChecked
			},
			() => {
				this.props.isCompleted(isChecked);
			}
		);
	}

	getData() {
		const {paymentMethod} = this.props
		let inputData = this.state;
		inputData.paymentMethodCredit = paymentMethod.credit
		inputData.paymentMethodDebit = paymentMethod.debit
		inputData.paymentMethodPix = paymentMethod.pix
		let dataSend = {};

		for (var fieldName in inputData) {
			if (this.checkField(fieldName, inputData[fieldName])) {
				dataSend[fieldName] = inputData[fieldName];
			} else {
				dataSend[fieldName] = undefined;
			}
		}

		return dataSend;
	}

	render() {
		const { paymentMethod, pixDiscountPercentage} = this.props;
		this.props.onDataAdyen(this.getData());
		const terminal = this.props.terminal;

		if (this.props.adyenPayment) {
			this.sendPaymentForm();
		}
		
		let { CmDrConsulta } = this.props;
		const cmDrConsulta = CmDrConsulta.data;
		var totalValue = this.props.totalValue;
		let installments = [];
		const currencyFormat = new Intl.NumberFormat('pt-BR', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});

		for (let i = 0; i < this.props.installments; i++) {
			var value = i + 1;
			var label = '';
			var installmentValue = totalValue / value;
			if (value === 1) {
				label = '1x de R$ ' + currencyFormat.format(installmentValue);
			} else {
				label =
					`${value}x de R$ ` +
					currencyFormat.format(installmentValue) +
					` sem juros`;
			}

			let props = {};

			installments.push(
				<option key={i} value={value} {...props}>
					{label}
				</option>
			);
		}
		let installmentElm = '';

		if (installments?.length > 1) {
			installmentElm = ({ values, setFieldValue, handleBlur }) => {
				return (
					<FormField>
						<FormField className='form-select'>
							<Field
								className='form-control'
								id='installments'
								name='numberOfInstallment'
								as='select'
								onChange={e => {
									setFieldValue('numberOfInstallment', e.target.value);
									this.setState({ numberOfInstallment: e.target.value });
								}}
								onBlur={handleBlur}
								value={values.numberOfInstallment}
								required>
								{installments}
							</Field>
							<label htmlFor='installments'>Parcelamento</label>
						</FormField>
					</FormField>
				);
			};
		}
		let options = '';
		if (terminal?.length > 0) {
			options = terminal.map(terminal => (
				<option key={terminal.serial_number} value={terminal.serial_number}>
					{terminal.name + ' - ' + terminal.serial_number}
				</option>
			));
		}
		return (
			<Formik
				initialValues={this.initialValues}
				validateOnChange
				validateOnBlur
				validateOnMount
				enableReinitialize
				onSubmit={() => {}}>
				{({ values, errors, touched, setFieldValue, handleBlur }) => {
					return (
						<Form>
							<FormField>
								<FormField className='form-terms'>
									<div style={{ display: 'flex', flexDirection: 'row' }}>
										<div style={{ marginRight: 20}}>
											<label className='switch'>
												<input
													checked={paymentMethod.credit}
													type='checkbox'
													required
													name='credit'
													id='credito'
													onChange={this.handlePaymentMethod}
												/>
												<span className='slider round'></span>
												<span>Cartão de Credito</span>
											</label>
										</div>
										<div style={{ marginRight: 20}}>
											<label className='switch'>
												<input
													checked={paymentMethod.debit}
													type='checkbox'
													required
													name='debit'
													id='debito'
													onChange={this.handlePaymentMethod}
												/>
												<span className='slider round'></span>
												<span>Cartão de Debito</span>
											</label>
										</div>
										<div style={{ marginRight: 20 }}>
											<label className='switch'>
												<input
													checked={paymentMethod.pix}
													type='checkbox'
													required
													name='pix'
													id='pix'
													onChange={this.handlePaymentMethod}
												/>
												<span className='slider round'></span>
												<span>Pix</span>
											</label>
										</div>
									</div>
									{this.state.errorOnField.paymentMethod && (
											<div className='error-msg'>
												<FiAlertCircle size={13} />
												<small className='credit-card-error'>
												{this.state.errorOnField.paymentMethod}
												</small>
											</div>
										)}
								</FormField>
							</FormField>
							<FormField className='inputHeight'>
								{this.props.installments > 1 &&
								paymentMethod.credit ? (
									installmentElm({ values, setFieldValue, handleBlur })
								) : (
									<FormField>
										<FormField>
											<Field
												className='form-control'
												id='installments'
												name='numberOfInstallment'
												value={
													paymentMethod.debit? 'À vista' : 
													paymentMethod.pix? `À vista (${pixDiscountPercentage}% no pix)`:
													 'Selecione um método de pagamento'}
												required></Field>
										</FormField>
									</FormField>
								)}
							</FormField>
							<FormField>
								<FormField className='form-select'>
									<Field
										className='form-control'
										id='terminal'
										name='terminal'
										as='select'
										onChange={e => {
											setFieldValue('terminal', e.target.value);

											let obj = terminal.filter(data => {
												return data.serial_number === e.target.value;
											});

											this.clearErrorOnFocus('terminal');
											this.setState({ terminal: obj[0] }, () => {
												this.props.isCompleted(false);
											});
										}}
										onBlur={handleBlur}
										value={values.terminal}
										required>
										<option defaultValue={true} key='standard' value={null}>
											Selecione um terminal
										</option>
										{options}
									</Field>
									<label htmlFor='installments'>Maquininha</label>
									{this.state.errorOnField.terminal && (
										<div className='error-msg'>
											<FiAlertCircle size={13} />
											<small className='credit-card-error'>
												{this.state.errorOnField.terminal}
											</small>
										</div>
									)}
								</FormField>
							</FormField>
							<FormField>
								<FormField data-cy='btn-slider' className='form-terms'>
									<TermAndConditions
										changeTerm={this.changeTerm}
										cmDrConsulta={CmDrConsulta.data}
									/>
									{this.state.errorOnField.termos && (
										<div className='error-msg'>
											<FiAlertCircle size={13} />
											<small className='credit-card-error'>
												{this.state.errorOnField.termos}
											</small>
										</div>
									)}
								</FormField>
							</FormField>
						</Form>
					);
				}}
			</Formik>
		);
	}
}
const mapStateToProps = state => ({
	paymentMethod: state.CmDrConsulta.paymentMethod,
	pixDiscountPercentage: state.Order.value.pixPercentage
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{ setPaymentMethod },
		dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(FormAdyen);
